"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.researchTypes = void 0;
// TODO: Move this const to the GiftResearchFlow.types and replace by enum.
var researchTypes = {
  AI: 'ai_research_type',
  FULL: 'full_research_type',
  UNKNOWN: 'unknown_research_type'
};
exports.researchTypes = researchTypes;